import React from "react";
import styles from "./FactoidVacancy.module.scss";
import DOMPurify from 'dompurify';
const FactoidVacancy = (props) => {
  const {color, title, description, size} = props;
  let classWrap = `${styles.wrap}`;
  if (color !== undefined && styles[`wrap_${color}`] !== undefined) {
    classWrap += ` ${styles[`wrap_${color}`]}`;
  }
  if (size !== undefined && styles[`wrap_${size}`] !== undefined) {
    classWrap += ` ${styles[`wrap_${size}`]}`;
  }
  return (
    <>
      <div className={classWrap}>
        <div className={styles.header}>
          <div className={styles.icon}></div>
          <div className={styles.title} dangerouslySetInnerHTML={{__html: DOMPurify.sanitize(title)}}></div>
        </div>
        <div className={styles.text}>
          {description}
        </div>
      </div>
    </>
  );

}

export default FactoidVacancy;
